/* eslint-disable no-plusplus */

/*  MUI  */
import { Download } from '@mui/icons-material';
import {
    Alert,
    AlertTitle,
    Box,
    Button,
    Chip,
    Typography
} from '@mui/material';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';
import { Notify } from 'application/Shared/Helpers';

/*  React  */
import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { withTranslation } from 'react-i18next';

const downloadFile = (params) => {
    const { contents, filename } = params;
    const element = document.createElement('a');
    const file = new Blob([contents], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = filename;
    document.body.appendChild(element);
    element.click();
};

class Steps extends Component {
    constructor(props) {
        super(props);
        this.state = { loaded: false };
    }

    componentDidMount() {
        this.setState({ loaded: true });
    }

    renderScript = (step) => {
        const { t } = this.props;
        const { copyValue } = step;

        return (
            <CopyToClipboard
                text={step.copyValue}
                onCopy={() => {
                    Notify.s(t('Common.copied'));
                }}
            >
                <Alert
                    severity="success"
                    icon={false}
                    action={
                        <Button
                            data-trackid="partner_integrations_steps_clickToCopy"
                            color="primary"
                            variant="outlinedTransparent"
                            size="small"
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            {t('Common.click_to_copy')}
                        </Button>
                    }
                    sx={{
                        backgroundColor: 'scripts.backgroundColor',
                        borderColor: 'scripts.borderColor',
                        cursor: 'pointer',
                        marginTop: '16px'
                    }}
                >
                    <Typography variant="codeBlock">{copyValue}</Typography>
                </Alert>
            </CopyToClipboard>
        );
    };

    renderDownload = (step) => {
        const { t } = this.props;
        const { copyValue, download } = step;

        return (
            <Button
                data-testid="integrationStepsDownloadFile"
                data-trackid="partner_integrations_steps_downloadFile"
                variant="contained"
                color="primary"
                size="small"
                onClick={() =>
                    downloadFile({
                        contents: copyValue,
                        filename: download
                    })
                }
            >
                <Download
                    style={{ fontSize: FontSizes[2], marginRight: '4px' }}
                />
                {t('Common.download_script')}
            </Button>
        );
    };

    render() {
        const { steps, t } = this.props;
        const { loaded } = this.state;

        if (!loaded) {
            return null;
        }

        let num = 1;

        return (
            <Box data-testid="integrationSteps">
                {steps.map((step, index) => (
                    <Box
                        // eslint-disable-next-line react/no-array-index-key
                        key={`step_${index}`}
                        mb="16px"
                        sx={{ color: 'text.primary' }}
                        data-testid={`integrationStepsMap_${index}`}
                        data-trackid={`integrationStepsMap_${index}`}
                        width="100%"
                    >
                        {step.note && (
                            <Alert severity="info" icon={false}>
                                <AlertTitle style={{ fontWeight: 600 }}>
                                    {t('Common.important_note')}
                                </AlertTitle>
                                {step.note}
                            </Alert>
                        )}
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            data-trackid={`integrationStepsMap_${index}_outerWrapper`}
                            width="100%"
                        >
                            <Box
                                display="flex"
                                alignItems="baseline"
                                flex={1}
                                data-trackid={`integrationStepsMap_${index}_stepComponentsWrapper`}
                            >
                                {step.step && (
                                    <Box
                                        as="span"
                                        mr="8px"
                                        style={{ fontWeight: 600 }}
                                    >
                                        {num++}.
                                    </Box>
                                )}
                                {step.component}
                                {step.stepValue && (
                                    <Chip
                                        label={step.stepValue}
                                        variant="secondary"
                                        sx={{ marginLeft: '4px' }}
                                    />
                                )}
                                {step.stepUrl && (
                                    <a
                                        href={step.stepUrl}
                                        target="_blink"
                                        className="link--secondary"
                                        style={{ marginLeft: '4px' }}
                                        data-trackid={`integrationStepsMap_${index}_stepURL`}
                                    >
                                        {`${step.stepUrl}.`}
                                    </a>
                                )}
                            </Box>
                            {step.download && (
                                <Box
                                    minWidth="170px"
                                    data-trackid={`integrationStepsMap_${index}_downloadWrapper`}
                                >
                                    {this.renderDownload(step)}
                                </Box>
                            )}
                        </Box>
                        {step.copyValue && this.renderScript(step)}
                    </Box>
                ))}
            </Box>
        );
    }
}
export default withTranslation()(Steps);
